import React, { Component } from 'react';
import { Icon, Input, Button } from 'antd';
import { connect } from 'react-redux';
import zmailLogo from '../../img/zmail_logo.png';
import '../../combinedStyles';
import EmailVerfication from './EmailVerification';

import userService from '../../services/userService';
import store from '../../reducers/store';

import positionsService from '../../services/positionsService';
import conferenceService from '../../services/conferenceService';
import locationService from '../../services/locationService';
import statusService from '../../services/statusService';
import UsersService from '../../services/userService';

class FirstTimeLogin extends Component {
  constructor(props) {
    super(props);

    this.userService = userService;

    this.state = {
      newPassword: '',
      passwordConfirm: '',
      email: this.props.email,
      error: null,
      verificationCode: null,
      loginStatus: null,
    };
  }

  handleNewPasswordChange(event) {
    this.setState({
      newPassword: event.target.value,
      error: null,
      loginStatus: null,
    });
  }

  handlePasswordConfirmChange(event) {
    this.setState({
      passwordConfirm: event.target.value,
      error: null,
      loginStatus: null,
    });
  }

  handleEmailChange(event) {
    this.setState({
      email: event.target.value,
      error: null,
      loginStatus: null,
    });
  }

  validateEmail(email) {
    var reg =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // console.log('email valid:', reg.test(answer));
    return reg.test(email);
  }

  async submitNewPassword() {
    this.setState({
      loginStatus: <Icon type='loading' />,
    });

    if (this.validateForm() === false) {
      return;
    }

    try {
      const res = await UsersService.resetPasswordForNewUser(
        this.state.email,
        this.props.oldPassword,
        this.state.newPassword
      ).catch((e) => {
        this.setState({
          error: e.message,
          loginStatus: null,
        });
      });

      const user = await UsersService.getUser(res.signInUserSession.accessToken.payload.sub);

      UsersService.resetOrgThroughHeaders(JSON.stringify(user.organization));

      window.localStorage.setItem('username', user.username);

      store.dispatch({ type: 'UPDATE_FILTERS', filters: user.filters });
      store.dispatch({ type: 'UPDATE_ACTIVE_USER', activeUser: user });
      store.dispatch({ type: 'UPDATE_ORG', organization: user.organization });

      const positions = await positionsService.get();
      const conferences = await conferenceService.getConferences();
      const states = await locationService.getStates();
      const status = await statusService.getStatuses();

      this.props.history.push('/dashboard');
    } catch (e) {
      this.setState({
        error: e.message,
        loginStatus: null,
      });
    }
  }

  validateForm() {
    if (
      this.state.newPassword === '' ||
      this.state.passwordConfirm === '' ||
      this.state.email === ''
    ) {
      this.setState({
        error: '*Please fill out all fields',
        loginStatus: null,
      });
      return false;
    }

    if (this.state.newPassword.length < 6) {
      this.setState({
        error: '*Password must be at least 6 characters',
        loginStatus: null,
      });
      return false;
    }

    if (this.validateEmail(this.state.email) === false) {
      this.setState({
        error: '*Please enter a valid email address',
        loginStatus: null,
      });
      return false;
    }

    return true;
  }

  handleKeyDown(event) {
    if (event.keyCode == 13) document.getElementById('loginBtn').click();
  }

  render() {
    var errorStyle = {
      color: 'red',
    };

    var securityMessageStyle = {
      color: 'black',
      width: '200%',
      alignItems: 'center',
    };

    var errorMessage = (
      <p style={errorStyle}>
        {this.state.error}
        <br></br>
        <br></br>
        Keep in mind that you need to enter a valid email adress and that your new password should
        have at least 6 characters.
      </p>
    );

    const error = this.state.error != null ? errorMessage : null;

    return (
      <div className='loginPage'>
        <img src={zmailLogo} className='loginLogo' alt='ZMail Logo' />
        <p style={securityMessageStyle}>
          <br></br>
          <br></br>
          It seems this is your first time logging in.
          <br></br>
          <br></br>
          For security purposes, we require that you input your new password and email before
          proceeding to use our software.
          <br></br>
          <br></br>
        </p>
        <div className='loginDiv' onKeyDown={this.handleKeyDown.bind(this)}>
          <Input
            size='large'
            prefix={<Icon type='mail' style={{ fontSize: 13 }} />}
            id='email'
            type='email'
            placeholder='Email'
            onChange={this.handleEmailChange.bind(this)}
            value={this.state.email}
          />
          <Input
            size='large'
            prefix={<Icon type='lock' style={{ fontSize: 13 }} />}
            autoComplete='new-password'
            id='newPassword'
            type='password'
            placeholder='Old Password'
            onChange={this.handleNewPasswordChange.bind(this)}
            value={this.state.newPassword}
          />
          <Input
            size='large'
            prefix={<Icon type='lock' style={{ fontSize: 13 }} />}
            autoComplete='new-password'
            id='passwordConfirm'
            type='password'
            placeholder='New Password'
            onChange={this.handlePasswordConfirmChange.bind(this)}
            value={this.state.passwordConfirm}
          />
          <p className='loginStatus'>{this.state.loginStatus}</p>
          {error}
          <Button
            id='loginBtn'
            type='primary'
            htmlType='submit'
            className='loginButton'
            onClick={this.submitNewPassword.bind(this)}>
            Submit
          </Button>
          <br></br>
          <p className='loginMessage'>
            Need help?{' '}
            <a href='mailto:info@zcruit.com?Subject=Zcruit%20Password%20Forgot'>Contact Us</a>
          </p>
        </div>
      </div>
    );
  }
}

function mapStoreToProps(storeState) {
  return {
    loggedIn: storeState.main.loggedIn,
  };
}

export default connect(mapStoreToProps)(FirstTimeLogin);



// WEBPACK FOOTER //
// ./src/components/login/FirstTimeLogin.js